import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './css/RelatedProducts.css'; // Make sure to create a CSS file to style the cards.

const RelatedProducts = ({ title, type, config, compareList, addToCompare, removeFromCompare }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [selectedReturnPeriod, setSelectedReturnPeriod] = useState('5y'); // Default return period
  const [showFeatures, setShowFeatures] = useState(false);
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    fetchProductData();
  }, [first, rows, sortField, sortOrder]);

  const fetchProductData = async () => {
    try {
      setLoading(true);
      const offset = first;
      const limit = rows;
      const sort_by = sortField ? sortField : 'sort_order';
      const sort_order = sortOrder === 1 ? 'asc' : 'desc';
      const response = await axios.get(`${config.PY_API_URL}related/products`, {
        params: {
          offset,
          limit: 5,
          sort_by,
          sort_order,
          return_periods: '3',
          product_code: config.product_code,
          type
        }
      });

      const { data } = response;
      if (data && data.data && data.data.products) {
        setProducts(data.data.products);
        setTotalRecords(data.data.total_count);
      } else {
        setProducts([]);
        setTotalRecords(0);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching product data:', error);
      setLoading(false);
    }
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const onSort = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };

  const handleReturnPeriodChange = (e) => {
    setSelectedReturnPeriod(e.target.value);
  };

  const renderInsuranceCard = (fund) => {
    let attributes = fund.attributes;
    if (typeof attributes === "string") {
        try {
            attributes = JSON.parse(attributes);
        } catch (e) {
            console.error("Error parsing attributes JSON:", e);
            attributes = [];
        }
    }
    attributes = Array.isArray(attributes) ? attributes : [];
    const getJsonValue = (key) => {
        if (!attributes.length) return null;
        try {
            const attr = attributes.find(attr => attr.key === key);
            if (!attr) return null;
            try {
                return JSON.parse(attr.value);
            } catch (e) {
                // console.error(`Error parsing ${key}:`, e);
                return attr.value; // Return as is if parsing fails
            }
        } catch (e) {
            console.error(`Error getting ${key}:`, e);
            return null;
        }
    };

    const bannerInfo = getJsonValue('Banner Info');
    const coverageDetails = getJsonValue('Coverage Details');
    const features = getJsonValue('Features');

    return (
        <div className="insurance-product-details" style={{width:'100%'}}>
            {
              (bannerInfo && Object.keys(bannerInfo).length > 0) && (
                <div className="insurance-banner">
                {bannerInfo && Object.entries(bannerInfo).map(([key, value]) => (
                    <div key={key} className={`banner-${key}`}>
                        <i className={`fas ${value.icon}`}></i>
                        <span>{value.text}</span>
                    </div>
                ))}
                </div>
              )
            }

            <div className="insurance-header">
                <div className="coverage-details">
                    {
                      (coverageDetails?.amount) && (
                        <div>
                            <div className="coverage-label">Cover amount</div>
                            <div className="coverage-amount">
                            {coverageDetails?.amount || 'N/A'}
                        </div>
                        </div>
                      )
                    }
                    {
                      (coverageDetails?.premium) && (
                        <div>
                            <div className="starting-label">Starting at</div>
                            <div className="premium-amount">
                            {coverageDetails?.premium || 'N/A'}
                        </div>
                        </div>
                      )
                    }
                </div>
                {
                  (coverageDetails?.discount) && (
                    <div className="online-discount">
                      Inclusive of {coverageDetails?.discount}
                  </div>
                )}
            </div>

            <div className="features-list">
            {
              Array.isArray(features) && features.length > 0 ? (
                features.map((feature, index) => (
                  <div key={index} className={`feature-item ${feature.isPrimary ? 'heart' : ''}`}>
                    <i className={`fas ${feature.icon}`}></i>
                    <span>{feature.text}</span>
                  </div>
                ))
              ) : (
                <></>
              )
            }
            </div>
            {
              (features?.length > 0) && (
                <i className="fas fa-info-circle view-more-icon" 
                  onClick={() => setShowFeatures(true)} />
              )
            }
        </div>
    );
  };

  return (
    <div className="product-list-container">
      {products && products.length > 0 ? (
        <div>
          <div className='product-list-container-head'>
          <h4>{title || 'Related Products'}</h4>
          {config.product_type_code === 1 && <>
              <select
                value={selectedReturnPeriod}
                onChange={handleReturnPeriodChange}>
                <option value="1y">1 Year</option>
                <option value="3y">3 Years</option>
                <option value="5y">5 Years</option>
                <option value="rsi">Since Inception</option>
              </select>
              </>
            }
          </div>
          <div className="product-cards">
            {products.map((product, index) => (
              <div className="product-card" key={index}>
                <a href={`${config.siteUrl}/product-detail/${product['product_code']}`}>
                  <div className="product-name" style={{color: '#000'}}>
                    <div>
                      Category: {product['category_name']}
                    </div>
                    <div>
                      {product['name']}
                    </div>
                  </div>
                  <div style={{color: '#000'}}>
                    {product.product_type_code === 1 && (
                      <div className="product-info">
                        <div className='product-card-item'><strong>NAV:</strong> {product.nav || 'N/A'}</div>
                        <div className='product-card-item'><strong>Returns:</strong>
                          {selectedReturnPeriod === '1y' && (product.returns_1_year ? `${product.returns_1_year}%` : 'N/A')}
                          {selectedReturnPeriod === '3y' && (product.returns_3_years ? `${product.returns_3_years}%` : 'N/A')}
                          {selectedReturnPeriod === '5y' && (product.returns_5_years ? `${product.returns_5_years}%` : 'N/A')}
                          {selectedReturnPeriod === 'rsi' && (product.rsi ? `${product.rsi}%` : 'N/A')}
                        </div>
                        <div className='product-card-item'>
                          {compareList.some((p) => p.product_code === product.product_code) ? (
                            <button onClick={() => removeFromCompare(product)}>Remove</button>
                          ) : (
                            <button onClick={() => addToCompare(product)}>Compare</button>
                          )}
                        </div>
                      </div>
                    )} 
                    {product?.product_type_code == 2 && <div className="booking-widget-inline-container">
                      {renderInsuranceCard(product)}
                      </div>
                    }
                  </div>
                </a>
              </div>
            ))}
          </div>

          <div className="view-more-products">
            <a href={`https://app.moneymarche.com/app/search?categories=${config.categoryId}`}>View More</a>
          </div>
        </div>
      ) : (
        <p>No products available</p>
      )}
    </div>
  );
};

export default RelatedProducts;
